import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageWhyChooseFeatures } from "../components/Venues/ManageWhyChooseFeatures";

export const VenueWhyChooseFeaturesPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageWhyChooseFeatures />
        </div>
      </div>
    </div>
  );
};